import { useTimer } from 'src/hooks/useTimer'
import type { Race } from 'src/types/domain/Race'
import { isRaceScheduled } from 'src/utils/raceUtils'

type Props = Readonly<{
  race: Race
}>

export function GameCardTimer({ race }: Props) {
  const { eventInfo } = useTimer({ race })

  if (!eventInfo) {
    return null
  }

  return (
    <>
      {isRaceScheduled(race) && (
        <>
          {eventInfo.label && <span className="event-label">{eventInfo.label}</span>}
          <span className="event-label">{eventInfo.getTime()}</span>
        </>
      )}
    </>
  )
}
